export const STATUS = {
  0: "Chờ",
  1: "Đang chạy",
  2: "Đã hết giờ",
  3: "Đã chốt",
  9: "Đã hủy",
};

export const STATUS_HELP = {
  0: "Chưa tới giờ bắt đầu, vẫn sửa được mọi thứ.",
  1: "Đang chạy: chỉ được rút ngắn giờ kết thúc, sửa chữ và hình.",
  2: "Đã hết giờ, máy chủ sắp chốt và gửi thưởng (khoảng 2 phút sau giờ kết thúc).",
  3: "Đã chốt và gửi thưởng. Chỉ xem được.",
  9: "Đã huỷ, không chốt thưởng.",
};

export const STATUS_COLOR = {
  0: "default",
  1: "success",
  2: "warning",
  3: "info",
  9: "error",
};

/** event_reward.kind, khớp EventMilestone / ServerGoalModule trên GServer. */
export const REWARD_KINDS = {
  0: {
    label: "Thưởng hạng",
    from: "Từ hạng",
    hint: "Gửi thư lúc chốt mùa theo hạng trên bảng top",
  },
  1: { label: "Mốc điểm", from: "Điểm cần", hint: "Người chơi tự nhận ở NPC khi đủ điểm" },
  2: {
    label: "Mốc cao cấp",
    from: "Điểm cần",
    hint: "Như mốc điểm, chỉ người có pass_premium = 1 mới nhận",
  },
  3: {
    label: "Mốc toàn server",
    from: "Tổng server cần",
    hint: "Tổng điểm cả server đạt mức này thì mọi người có điểm được quà",
  },
};

export const PERIODS = { day: "Ngày", week: "Tuần", month: "Tháng" };

/** "2026-10-19T08:00:00" → "2026-10-19T08:00" cho ô datetime-local. */
export function toInputTime(value) {
  return value ? String(value).slice(0, 16) : "";
}

export function showTime(value) {
  if (!value) return "";
  const text = String(value).replace("T", " ");
  return text.slice(0, 16);
}

export function parseJson(text, fallback = null) {
  if (text === null || text === undefined || text === "") return fallback;
  if (typeof text !== "string") return text;
  try {
    return JSON.parse(text);
  } catch (e) {
    return fallback;
  }
}

/** Các score_key có trong cấu hình mùa: bảng top và điểm của các khối. */
export function scoreKeys(config) {
  const keys = new Set();
  (config?.boards || []).forEach((board) => board?.key && keys.add(board.key));
  Object.values(config?.modules || {}).forEach((module) => {
    if (module && typeof module === "object") {
      ["score", "score_recv"].forEach((field) => module[field] && keys.add(module[field]));
    }
  });
  return [...keys];
}

export function boardName(config, key) {
  const board = (config?.boards || []).find((row) => row.key === key);
  return board?.name || key;
}
